import { render, staticRenderFns } from "./SwitchAccountButton.vue?vue&type=template&id=a844af58"
import script from "./SwitchAccountButton.vue?vue&type=script&lang=js"
export * from "./SwitchAccountButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports